import React, { useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from '@/hooks/useTranslation';

const AutodataStubPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const iframe = document.getElementById('js-frame');
      if (iframe) {
        iframe.style.height = `${event.data}px`;
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    <Box
      sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        {t('autodata.title')}
      </Typography>
      <iframe
        id="js-frame"
        src={import.meta.env.VITE_AUTODATA_IFRAME_URL}
        style={{ border: 'none', width: '100%', minHeight: '400px' }}
      />
    </Box>
  );
};

export default AutodataStubPage;
